import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// POST /api/v1/teacher-payouts/
// Body: { teacher, period_start, period_end }
// → 201 { id, teacher, period_start, period_end, hours_total, amount_total, status:"PAID", paid_at }
// Contract: TASK-15 §8
function useSettlePayout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiClient.post("/api/v1/teacher-payouts/", data).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["teacher-payouts", "preview"] });
      qc.invalidateQueries({ queryKey: ["teacher-payouts", "history"] });
    },
  });
}

export { useSettlePayout };
